import { render, staticRenderFns } from "./ShowVrTour.vue?vue&type=template&id=5ecf9edb&scoped=true&"
import script from "./ShowVrTour.vue?vue&type=script&lang=js&"
export * from "./ShowVrTour.vue?vue&type=script&lang=js&"
import style0 from "./ShowVrTour.vue?vue&type=style&index=0&id=5ecf9edb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf9edb",
  null
  
)

export default component.exports